import { type FC } from 'react';

export const SupportLink: FC = () => (
  <a
    className="link normal-case text-leland-primary"
    href="mailto:support@joinleland.com"
    target="_blank"
    rel="noreferrer"
    id="support_link--contact_support"
  >
    support@joinleland.com
  </a>
);
